<template>
  <div class="unauthorized">
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card class="pa-6" elevation="8">
            <v-card-text class="text-center">
              <v-icon size="80" color="warning" class="mb-4">
                mdi-shield-alert-outline
              </v-icon>

              <h1 class="display-1 mb-3">{{ $t('auth.unauthorized.title') }}</h1>
              <p class="headline grey--text mb-4">
                {{ $t('auth.unauthorized.message') }}
              </p>

              <div class="mb-4">
                <p class="body-1">
                  {{ $t('auth.unauthorized.description') }}
                </p>
              </div>

              <v-divider class="my-4"></v-divider>

              <div class="d-flex flex-column flex-sm-row justify-center align-center">
                <v-btn
                  color="primary"
                  large
                  class="ma-2"
                  @click="goHome"
                >
                  <v-icon left>mdi-home</v-icon>
                  {{ $t('auth.unauthorized.goHome') }}
                </v-btn>

                <v-btn
                  color="secondary"
                  large
                  outlined
                  class="ma-2"
                  @click="signOut"
                  :loading="signingOut"
                >
                  <v-icon left>mdi-logout</v-icon>
                  {{ $t('auth.unauthorized.signOut') }}
                </v-btn>
              </div>

              <div class="mt-4">
                <p class="caption grey--text">
                  {{ $t('auth.unauthorized.contactAdmin') }}
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
    name: "Unauthorized",
    data() {
        return {
            signingOut: false
        };
    },
    methods: {
        goHome() {
            this.$router.push({ name: "Home" });
        },

        async signOut() {
            this.signingOut = true;

            try {
                await this.$AuthService.signOut();
            } catch (error) {
                // Sign out error - fallback: reload page
                window.location.reload();
            } finally {
                this.signingOut = false;
            }
        }
    }
};
</script>

<style scoped>
.unauthorized {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  min-height: 100vh;
}

.v-card {
  border-radius: 16px;
  max-width: 100%;
}

.display-1 {
  font-weight: 300;
}

@media (max-width: 600px) {
  .d-flex.flex-sm-row {
    flex-direction: column;
  }
}
</style>
